import { Subscription } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReloadEventEmitterService {

  invokeAnalysisReportEnterpriseFunction = new EventEmitter();
  invokeLandingPageFunction = new EventEmitter();
  invokeNumberCart = new EventEmitter();
  subscriptionVar: Subscription;
  constructor() { }

  /*call function in Component Analysis Report*/
  onAnalysisReportEnterpriseFunction() {
    this.invokeAnalysisReportEnterpriseFunction.emit();
  }

  /*call function in Component Landing page*/
  onLandingPageFunction() {
    this.invokeLandingPageFunction.emit();
  }
  
  onLoadNumberCart(){
    this.invokeNumberCart.emit();
  }
}
